import { useState } from 'react';
import Layout from '../../../../components/layout/Layout';

interface ParticipanteCSV {
  nome: string;
  email: string;
  telefone: string;
  celular: string;
  cpf?: string;
  cnpj?: string;
  departamento: string;
  cargo: string;
  endereco: string;
  cidade: string;
  estado: string;
  cep: string;
  status: 'pendente' | 'validado' | 'erro';
  erro?: string;
}

export default function EfetuarCadastrosPage() {
  const [modalidadeAtiva, setModalidadeAtiva] = useState<'csv' | 'manual'>('csv');
  const [arquivoCSV, setArquivoCSV] = useState<File | null>(null);
  const [dadosCSV, setDadosCSV] = useState<ParticipanteCSV[]>([]);
  const [processandoCSV, setProcessandoCSV] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [tipoParticipante, setTipoParticipante] = useState<'fisica' | 'juridica'>('fisica');
  const [showManualModal, setShowManualModal] = useState(false);
  
const [dropdownGrupoAberto, setDropdownGrupoAberto] = useState(false);
    const [gruposTrabalho, setGruposTrabalho] = useState<string[]>([
    'Financeiro',
    'Operacional',
    'Atendimento',
    'Vendas',
    'Marketing',
    'TI'
  ]);
  const [novoGrupo, setNovoGrupo] = useState('');
  const [showAddGrupoModal, setShowAddGrupoModal] = useState(false);
  
  const [formData, setFormData] = useState({
    // Dados Básicos
    tipoParticipante: 'fisica',
    nome: '',
    email: '',
    telefone: '',
    celular: '',
    
    // Pessoa Física
    cpf: '',
    rg: '',
    dataNascimento: '',
    estadoCivil: '',
    profissao: '',
    
    // Pessoa Jurídica
    cnpj: '',
    inscricaoEstadual: '',
    razaoSocial: '',
    nomeFantasia: '',
    porte: '',
    ramoAtividade: '',
    
    // Endereço
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    pais: 'Brasil',
    
    // Dados Bancários
    banco: '',
    agencia: '',
    conta: '',
    tipoConta: '',
    chavePix: '',
    
    // Dados Profissionais
    departamento: '',
    cargo: '',
    gruposTrabalhoSelecionados: [] as string[],
    dataAdmissao: '',
    salario: '',
    supervisor: '',
    
    // Informações do Programa
    nivelInicial: 'Bronze',
    pontosIniciais: '0',
    metaIndividual: '',
    observacoes: '',
    
    // Configurações
    receberNotificacoes: true,
    receberEmail: true,
    receberSMS: false,
    participarRanking: true,
    
    // Documentos
    documentos: [] as File[]
  });

  const departamentos = ['Vendas', 'Marketing', 'Atendimento', 'Financeiro', 'RH', 'TI'];

  const mockDadosCSV: ParticipanteCSV[] = [
    {
      nome: 'João Silva Santos',
      email: 'joao.silva@empresa.com',
      telefone: '(11) 3333-4444',
      celular: '(11) 99999-1111',
      cpf: '123.456.789-00',
      departamento: 'Vendas',
      cargo: 'Consultor de Vendas',
      endereco: 'Rua das Flores, 123',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01234-567',
      status: 'validado'
    },
    {
      nome: 'Maria Oliveira Costa',
      email: 'maria.oliveira@empresa.com',
      telefone: '(11) 3333-5555',
      celular: '(11) 99999-2222',
      cpf: '987.654.321-00',
      departamento: 'Marketing',
      cargo: 'Analista de Marketing',
      endereco: 'Av. Paulista, 456',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01310-100',
      status: 'validado'
    },
    {
      nome: 'Pedro Rodrigues Lima',
      email: 'pedro.rodrigues@empresa.com',
      telefone: '(11) 3333-6666',
      celular: '(11) 99999-3333',
      cpf: '456.789.123-00',
      departamento: 'TI',
      cargo: 'Desenvolvedor',
      endereco: 'Rua Augusta, 789',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01305-000',
      status: 'pendente'
    },
    {
      nome: 'Ana Carolina Souza',
      email: 'ana.souza@empresa.com',
      telefone: '(11) 3333-7777',
      celular: '(11) 99999-4444',
      cpf: '789.123.456-00',
      departamento: 'RH',
      cargo: 'Analista de RH',
      endereco: 'Rua Oscar Freire, 321',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01426-001',
      status: 'erro',
      erro: 'Email já cadastrado no sistema'
    },
    {
      nome: 'Carlos Eduardo Ferreira',
      email: 'carlos.ferreira@empresa.com',
      telefone: '(11) 3333-8888',
      celular: '(11) 99999-5555',
      cpf: '321.654.987-00',
      departamento: 'Financeiro',
      cargo: 'Analista Financeiro',
      endereco: 'Rua Consolação, 654',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01302-000',
      status: 'validado'
    }
  ];

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setArquivoCSV(file);
      setProcessandoCSV(true);
      
      // Simular processamento do arquivo CSV
      setTimeout(() => {
        setDadosCSV(mockDadosCSV);
        setProcessandoCSV(false);
        setShowPreview(true);
      }, 2000);
    }
  };

  const getStatusColor = (status: string) => {
    const colors = {
      'pendente': 'bg-yellow-100 text-yellow-800',
      'validado': 'bg-green-100 text-green-800',
      'erro': 'bg-red-100 text-red-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getStatusIcon = (status: string) => {
    const icons = {
      'pendente': 'ri-time-line',
      'validado': 'ri-check-line',
      'erro': 'ri-error-warning-line'
    };
    return icons[status as keyof typeof icons] || 'ri-question-line';
  };

  const handleProcessarCSV = () => {
    const validados = dadosCSV.filter(item => item.status === 'validado');
    alert(`${validados.length} participantes serão cadastrados no sistema.`);
    setShowPreview(false);
    setArquivoCSV(null);
    setDadosCSV([]);
  };

  const downloadTemplate = () => {
    const csvContent = `nome,email,telefone,celular,cpf,cnpj,departamento,cargo,endereco,cidade,estado,cep
João Silva Santos,joao.silva@empresa.com,(11) 3333-4444,(11) 99999-1111,123.456.789-00,,Vendas,Consultor de Vendas,Rua das Flores 123,São Paulo,SP,01234-567
Empresa ABC Ltda,contato@empresaabc.com,(11) 3333-5555,(11) 99999-2222,,12.345.678/0001-90,Marketing,Pessoa Jurídica,Av. Paulista 456,São Paulo,SP,01310-100`;
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'template_participantes.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAdicionarGrupo = () => {
    if (novoGrupo.trim() && !gruposTrabalho.includes(novoGrupo.trim())) {
      setGruposTrabalho([...gruposTrabalho, novoGrupo.trim()]);
      setNovoGrupo('');
      setShowAddGrupoModal(false);
    }
  };

  const handleRemoverGrupo = (grupo: string) => {
    if (confirm(`Deseja realmente remover o grupo "${grupo}"?`)) {
      setGruposTrabalho(gruposTrabalho.filter(g => g !== grupo));
      setFormData(prev => ({
        ...prev,
        gruposTrabalhoSelecionados: prev.gruposTrabalhoSelecionados.filter(g => g !== grupo)
      }));
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Efetuar Cadastros</h1>
            <p className="text-gray-600 mt-1">Cadastre participantes através de arquivo CSV ou inclusão manual</p>
          </div>
          <button
            onClick={() => window.history.back()}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            <span>Voltar</span>
          </button>
        </div>

        {/* Seletor de Modalidade */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Escolha a Modalidade de Cadastro</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <button
              onClick={() => setModalidadeAtiva('csv')}
              className={`p-6 rounded-lg border-2 transition-all duration-200 text-left ${
                modalidadeAtiva === 'csv'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  modalidadeAtiva === 'csv' ? 'bg-blue-500' : 'bg-gray-400'
                }`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-file-excel-line text-white text-xl"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Upload de Arquivo CSV</h3>
                  <p className="text-sm text-gray-600 mt-1">Importe múltiplos participantes de uma só vez</p>
                  <div className="flex items-center space-x-4 mt-2">
                    <span className="text-xs text-green-600 font-medium">✓ Cadastro em lote</span>
                    <span className="text-xs text-green-600 font-medium">✓ Validação automática</span>
                  </div>
                </div>
              </div>
            </button>

            <button
              onClick={() => setModalidadeAtiva('manual')}
              className={`p-6 rounded-lg border-2 transition-all duration-200 text-left ${
                modalidadeAtiva === 'manual'
                  ? 'border-emerald-500 bg-emerald-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  modalidadeAtiva === 'manual' ? 'bg-emerald-500' : 'bg-gray-400'
                }`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-user-add-line text-white text-xl"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Inclusão Manual</h3>
                  <p className="text-sm text-gray-600 mt-1">Cadastre participantes individualmente</p>
                  <div className="flex items-center space-x-4 mt-2">
                    <span className="text-xs text-green-600 font-medium">✓ Controle total</span>
                    <span className="text-xs text-green-600 font-medium">✓ Dados completos</span>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>

        {/* Conteúdo da Modalidade CSV */}
        {modalidadeAtiva === 'csv' && (
          <div className="space-y-6">
            {/* Instruções e Template */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Upload de Arquivo CSV</h3>
                  <div className="space-y-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <div className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-information-line text-white text-xs"></i>
                          </div>
                        </div>
                        <div>
                          <h4 className="text-sm font-semibold text-blue-900 mb-2">Instruções para o arquivo CSV</h4>
                          <ul className="text-sm text-blue-800 space-y-1">
                            <li>• O arquivo deve conter as colunas: nome, email, telefone, celular, cpf/cnpj, departamento, cargo, endereço, cidade, estado, cep</li>
                            <li>• Use vírgula (,) como separador de campos</li>
                            <li>• A primeira linha deve conter os cabeçalhos das colunas</li>
                            <li>• Para pessoa física, preencha o campo CPF. Para pessoa jurídica, preencha o campo CNPJ</li>
                            <li>• Máximo de 1000 registros por arquivo</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4">
                      <button
                        onClick={downloadTemplate}
                        className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-download-line"></i>
                        </div>
                        <span>Baixar Template CSV</span>
                      </button>
                      <span className="text-sm text-gray-600">Use este template como base para seu arquivo</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Upload Area */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                {!arquivoCSV ? (
                  <>
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-upload-cloud-line text-gray-400 text-2xl"></i>
                      </div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Faça upload do seu arquivo CSV</h3>
                    <p className="text-sm text-gray-600 mb-4">Arraste e solte o arquivo aqui ou clique para selecionar</p>
                    <input
                      type="file"
                      accept=".csv"
                      onChange={handleFileUpload}
                      className="hidden"
                      id="csvFile"
                    />
                    <label
                      htmlFor="csvFile"
                      className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg cursor-pointer transition-colors"
                    >
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-folder-open-line"></i>
                      </div>
                      Selecionar Arquivo CSV
                    </label>
                    <p className="text-xs text-gray-500 mt-2">Formatos aceitos: .csv (máx. 10MB)</p>
                  </>
                ) : (
                  <div className="space-y-4">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-file-excel-line text-green-600 text-2xl"></i>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">{arquivoCSV.name}</h3>
                      <p className="text-sm text-gray-600">Tamanho: {(arquivoCSV.size / 1024).toFixed(2)} KB</p>
                    </div>
                    {processandoCSV ? (
                      <div className="flex items-center justify-center space-x-2">
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                        <span className="text-sm text-gray-600">Processando arquivo...</span>
                      </div>
                    ) : (
                      <div className="flex items-center justify-center space-x-3">
                        <button
                          onClick={() => {
                            setArquivoCSV(null);
                            setDadosCSV([]);
                            setShowPreview(false);
                          }}
                          className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                        >
                          Remover Arquivo
                        </button>
                        {showPreview && (
                          <button
                            onClick={handleProcessarCSV}
                            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                          >
                            Processar Cadastros
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Preview dos Dados */}
            {showPreview && dadosCSV.length > 0 && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="p-6 border-b border-gray-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">Preview dos Dados</h3>
                      <p className="text-sm text-gray-600 mt-1">Verifique os dados antes de processar</p>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center space-x-2">
                        <div className="w-3 h-3 rounded-full bg-green-500"></div>
                        <span className="text-sm text-gray-600">{dadosCSV.filter(item => item.status === 'validado').length} Validados</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                        <span className="text-sm text-gray-600">{dadosCSV.filter(item => item.status === 'pendente').length} Pendentes</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="w-3 h-3 rounded-full bg-red-500"></div>
                        <span className="text-sm text-gray-600">{dadosCSV.filter(item => item.status === 'erro').length} Erros</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Departamento</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Documento</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Observações</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {dadosCSV.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center space-x-2">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(item.status)}`}>
                                <div className="w-3 h-3 flex items-center justify-center mr-1">
                                  <i className={getStatusIcon(item.status)}></i>
                                </div>
                                {item.status === 'validado' ? 'Validado' : 
                                 item.status === 'pendente' ? 'Pendente' : 'Erro'}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">{item.nome}</div>
                            <div className="text-sm text-gray-500">{item.cargo}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{item.email}</div>
                            <div className="text-sm text-gray-500">{item.celular}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className="text-sm text-gray-900">{item.departamento}</span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className="text-sm text-gray-900">{item.cpf || item.cnpj}</span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {item.erro ? (
                              <span className="text-sm text-red-600">{item.erro}</span>
                            ) : (
                              <span className="text-sm text-gray-500">-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="p-6 border-t border-gray-200 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-600">
                      Total de {dadosCSV.length} registros encontrados
                    </div>
                    <button
                      onClick={handleProcessarCSV}
                      className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line"></i>
                      </div>
                      <span>Processar {dadosCSV.filter(item => item.status === 'validado').length} Cadastros</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Conteúdo da Modalidade Manual */}
        {modalidadeAtiva === 'manual' && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-user-add-line text-emerald-600 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Inclusão Manual de Participantes</h3>
              <p className="text-gray-600 mb-6">Cadastre participantes individualmente com controle total sobre os dados</p>
              <button
                onClick={() => setShowManualModal(true)}
                className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap mx-auto"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-add-line"></i>
                </div>
                <span>Cadastrar Novo Participante</span>
              </button>
            </div>
          </div>
        )}

        {/* Modal de Cadastro Manual */}
        {showManualModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Cadastrar Novo Participante</h3>
                  <p className="text-sm text-gray-600 mt-1">Preencha todas as informações necessárias para o cadastro</p>
                </div>
                <button
                  onClick={() => setShowManualModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                <form className="space-y-8">
                  {/* Tipo de Participante */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Tipo de Participante</h4>
                    <div className="flex space-x-4">
                      <label className="flex items-center space-x-3 cursor-pointer">
                        <input
                          type="radio"
                          name="tipoParticipante"
                          value="fisica"
                          checked={tipoParticipante === 'fisica'}
                          onChange={(e) => setTipoParticipante(e.target.value as 'fisica' | 'juridica')}
                          className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        />
                        <span className="text-sm font-medium text-gray-700">Pessoa Física</span>
                      </label>
                      <label className="flex items-center space-x-3 cursor-pointer">
                        <input
                          type="radio"
                          name="tipoParticipante"
                          value="juridica"
                          checked={tipoParticipante === 'juridica'}
                          onChange={(e) => setTipoParticipante(e.target.value as 'fisica' | 'juridica')}
                          className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        />
                        <span className="text-sm font-medium text-gray-700">Pessoa Jurídica</span>
                      </label>
                    </div>
                  </div>

                  {/* Documentos */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Documentos</h4>
                    {tipoParticipante === 'fisica' ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CPF *</label>
                          <input
                            type="text"
                            required
                            value={formData.cpf}
                            onChange={(e) => setFormData({...formData, cpf: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000-00"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data de Nascimento</label>
                          <input
                            type="date"
                            value={formData.dataNascimento}
                            onChange={(e) => setFormData({...formData, dataNascimento: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CNPJ *</label>
                          <input
                            type="text"
                            required
                            value={formData.cnpj}
                            onChange={(e) => setFormData({...formData, cnpj: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="00.000.000/0000-00"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Inscrição Estadual</label>
                          <input
                            type="text"
                            value={formData.inscricaoEstadual}
                            onChange={(e) => setFormData({...formData, inscricaoEstadual: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000.000"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Dados Básicos */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Dados Básicos</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {tipoParticipante === 'fisica' ? 'Nome Completo' : 'Razão Social'} *
                        </label>
                        <input
                          type="text"
                          required
                          value={formData.nome}
                          onChange={(e) => setFormData({...formData, nome: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder={tipoParticipante === 'fisica' ? 'Digite o nome completo' : 'Digite a razão social'}
                        />
                      </div>
                      {tipoParticipante === 'juridica' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Nome Fantasia</label>
                          <input
                            type="text"
                            value={formData.nomeFantasia}
                            onChange={(e) => setFormData({...formData, nomeFantasia: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Digite o nome fantasia"
                          />
                        </div>
                      )}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                        <input
                          type="email"
                          required
                          value={formData.email}
                          onChange={(e) => setFormData({...formData, email: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Digite o email"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Celular *</label>
                        <input
                          type="tel"
                          required
                          value={formData.celular}
                          onChange={(e) => setFormData({...formData, celular: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="(11) 99999-8888"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Dados Profissionais */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Dados Profissionais</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Departamento *</label>
                        <select
                          required
                          value={formData.departamento}
                          onChange={(e) => setFormData({...formData, departamento: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                        >
                          <option value="">Selecione</option>
                          {departamentos.map(dept => (
                            <option key={dept} value={dept}>{dept}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Cargo *</label>
                        <input
                          type="text"
                          required
                          value={formData.cargo}
                          onChange={(e) => setFormData({...formData, cargo: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Digite o cargo"
                        />
                      </div>
                      
                      {/* CAMPO: Grupo de Trabalho - Multi-select */}
                      <div className="md:col-span-2">
                        <div className="flex items-center justify-between mb-2">
                          <label className="block text-sm font-medium text-gray-700">Grupo de Trabalho *</label>
                          <button
                            type="button"
                            onClick={() => setShowAddGrupoModal(true)}
                            className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center space-x-1 cursor-pointer whitespace-nowrap"
                          >
                            <div className="w-3 h-3 flex items-center justify-center">
                              <i className="ri-add-line"></i>
                            </div>
                            <span>Adicionar Novo Grupo</span>
                          </button>
                        </div>

                        {/* Dropdown Multi-select */}
                        <div className="relative">
                          <button
                            type="button"
                            onClick={() => setDropdownGrupoAberto(!dropdownGrupoAberto)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm text-left flex items-center justify-between bg-white cursor-pointer"
                          >
                            <span className={formData.gruposTrabalhoSelecionados.length > 0 ? 'text-gray-900' : 'text-gray-400'}>
                              {formData.gruposTrabalhoSelecionados.length > 0
                                ? `${formData.gruposTrabalhoSelecionados.length} grupo(s) selecionado(s)`
                                : 'Selecione os grupos de trabalho'}
                            </span>
                            <div className="w-4 h-4 flex items-center justify-center">
                              <i className={`ri-arrow-down-s-line transition-transform ${dropdownGrupoAberto ? 'rotate-180' : ''}`}></i>
                            </div>
                          </button>

                          {dropdownGrupoAberto && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                              {gruposTrabalho.map(grupo => (
                                <label
                                  key={grupo}
                                  className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer text-sm"
                                >
                                  <input
                                    type="checkbox"
                                    checked={formData.gruposTrabalhoSelecionados.includes(grupo)}
                                    onChange={() => {
                                      const selecionados = formData.gruposTrabalhoSelecionados;
                                      if (selecionados.includes(grupo)) {
                                        setFormData({
                                          ...formData,
                                          gruposTrabalhoSelecionados: selecionados.filter(g => g !== grupo)
                                        });
                                      } else {
                                        setFormData({
                                          ...formData,
                                          gruposTrabalhoSelecionados: [...selecionados, grupo]
                                        });
                                      }
                                    }}
                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mr-3"
                                  />
                                  <span className="text-gray-700">{grupo}</span>
                                </label>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Tags dos grupos SELECIONADOS */}
                        {formData.gruposTrabalhoSelecionados.length > 0 && (
                          <div className="mt-3 flex flex-wrap gap-2">
                            {formData.gruposTrabalhoSelecionados.map(grupo => (
                              <div key={grupo} className="inline-flex items-center space-x-1 px-3 py-1 bg-blue-50 border border-blue-200 rounded-full text-xs font-medium text-blue-900">
                                <span>{grupo}</span>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      gruposTrabalhoSelecionados: formData.gruposTrabalhoSelecionados.filter(g => g !== grupo)
                                    });
                                  }}
                                  className="w-3 h-3 flex items-center justify-center text-blue-600 hover:text-blue-800 cursor-pointer ml-1"
                                >
                                  <i className="ri-close-line text-xs"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Lista de grupos disponíveis com opção de remover da lista global */}
                        <div className="mt-4 pt-4 border-t border-gray-100">
                          <p className="text-xs text-gray-500 mb-2">Grupos disponíveis:</p>
                          <div className="flex flex-wrap gap-2">
                            {gruposTrabalho.map(grupo => (
                              <div key={grupo} className="inline-flex items-center space-x-1 px-2 py-1 bg-gray-50 border border-gray-200 rounded-full text-xs text-gray-600">
                                <span>{grupo}</span>
                                <button
                                  type="button"
                                  onClick={() => handleRemoverGrupo(grupo)}
                                  className="w-3 h-3 flex items-center justify-center text-gray-400 hover:text-red-500 cursor-pointer ml-1"
                                  title={`Remover "${grupo}" da lista`}
                                >
                                  <i className="ri-close-line text-xs"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Endereço */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Endereço</h4>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">CEP *</label>
                        <input
                          type="text"
                          required
                          value={formData.cep}
                          onChange={(e) => setFormData({...formData, cep: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="00000-000"
                        />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Endereço *</label>
                        <input
                          type="text"
                          required
                          value={formData.endereco}
                          onChange={(e) => setFormData({...formData, endereco: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Digite o endereço"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Número *</label>
                        <input
                          type="text"
                          required
                          value={formData.numero}
                          onChange={(e) => setFormData({...formData, numero: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="123"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Cidade *</label>
                        <input
                          type="text"
                          required
                          value={formData.cidade}
                          onChange={(e) => setFormData({...formData, cidade: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Digite a cidade"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Estado *</label>
                        <select
                          required
                          value={formData.estado}
                          onChange={(e) => setFormData({...formData, estado: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                        >
                          <option value="">Selecione</option>
                          <option value="SP">São Paulo</option>
                          <option value="RJ">Rio de Janeiro</option>
                          <option value="MG">Minas Gerais</option>
                          <option value="RS">Rio Grande do Sul</option>
                          <option value="PR">Paraná</option>
                          <option value="SC">Santa Catarina</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Botões de Ação */}
                  <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={() => setShowManualModal(false)}
                      className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowManualModal(false);
                        alert('Participante cadastrado com sucesso!');
                      }}
                      className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Cadastrar Participante
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Adicionar Novo Grupo de Trabalho */}
        {showAddGrupoModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-md mx-4">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h3 className="text-xl font-semibold text-gray-900">Adicionar Grupo de Trabalho</h3>
                <button
                  onClick={() => {
                    setShowAddGrupoModal(false);
                    setNovoGrupo('');
                  }}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Grupo</label>
                  <input
                    type="text"
                    value={novoGrupo}
                    onChange={(e) => setNovoGrupo(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Ex: Financeiro, Operacional, Atendimento..."
                    autoFocus
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleAdicionarGrupo();
                      }
                    }}
                  />
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                  <p className="text-xs text-blue-800">
                    O grupo de trabalho será adicionado à lista de opções disponíveis para seleção.
                  </p>
                </div>

                <div className="flex items-center justify-end space-x-3">
                  <button
                    onClick={() => {
                      setShowAddGrupoModal(false);
                      setNovoGrupo('');
                    }}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleAdicionarGrupo}
                    disabled={!novoGrupo.trim() || gruposTrabalho.includes(novoGrupo.trim())}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Adicionar Grupo
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}